import { render, staticRenderFns } from "./WsCrudTitleBar.vue?vue&type=template&id=47adab0a&"
import script from "./WsCrudTitleBar.vue?vue&type=script&lang=js&"
export * from "./WsCrudTitleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports